import { forEach, isEmpty } from 'lodash';
import { HttpParams } from '@angular/common/http';
import { BackendApiType, IFilterQuery, Primitive } from '../../types';
import { XVIHttpUrlEncodingCodec } from '../../services/base/xvi-http-url-encoding-codec';
import { BACKEND_API_TYPE_FIELD_PATH } from '../../constants';

/**
 * Method which creates HttpParams and returns
 */
const createParams = ({
  filter,
  select: selectArg,
  top,
  skip,
  orderby,
  expand,
  effectiveDate,
  include_entities,
  include_nested_type,
  customParams,
  include_items,
  include_calculated_values,
  config,
  // eslint-disable-next-line comma-dangle
  ...queryParams
}: IFilterQuery & { [key: string]: Primitive | object } = {}): HttpParams => {
  let params = new HttpParams({ encoder: new XVIHttpUrlEncodingCodec() });

  // add fixed BACKEND_API_TYPE_FIELD_PATH params, will remove by url.interceptor
  params = params.set(
    BACKEND_API_TYPE_FIELD_PATH,
    config?.backendApiType || BackendApiType.XVI,
  );
  // TODO find better solution for handling params
  if (filter) {
    params = params.set('$filter', filter);
  }
  if (!isEmpty(selectArg)) {
    params = params.set('$select', selectArg.toString());
  }
  if (top) {
    params = params.set('$top', top.toString());
  }
  if (skip) {
    params = params.set('$skip', skip.toString());
  }
  if (orderby) {
    params = params.set('$orderby', orderby.toString());
  }
  forEach(queryParams, (param, key) => {
    params = params.set(key, param.toString());
  });
  if (include_entities) {
    const entityList: string = include_entities
      .map((entityType) => `'${entityType}'`)
      .join(',');
    params = params.set('include_entities', `[${entityList}]`);
  }
  if (include_nested_type) {
    const typeList: string = include_nested_type
      .map((type) => `'${type}'`)
      .join(',');
    params = params.set('include_nested_type', `[${typeList}]`);
  }
  if (customParams) {
    customParams.map(({ key, value }) => {
      // eslint-disable-line
      params = params.set(key, String(value));
    });
  }
  if (expand) {
    params = params.set('$expand', expand.toString());
  }
  if (effectiveDate) {
    params = params.set('effective_date', effectiveDate);
  }
  if (include_items) {
    params = params.set('$include_items', include_items.toString());
  }
  if (include_calculated_values) {
    params = params.set(
      '$include_calculated_values',
      include_calculated_values.toString(),
    );
  }

  return params;
};

export { createParams };
